import { IntercomService } from './../../../shared/services/intercom.service';
import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { LocalStorageService } from '../services/local-storage.service';
import { UserWebService } from '../services/user.web.service';
import { ContentLoadService } from '../../../shared/services/content-load.service';

@Component({
  selector: 'auth-sso',
  templateUrl: '../templates/auth-sso.html',
  styleUrls: ['../scss/auth-sso.scss'],
})
export class AuthSsoComponent {
  accessToken: string;
  refreshToken: string;
  redirect: string;
  goBack: string;
  showLoading: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserWebService,
    private localStorage: LocalStorageService,
    private contentLoadService: ContentLoadService,
    public intercomService: IntercomService
  ) {
    this.contentLoadService.setLoadingData(['Autenticando...', true]);
    this.showLoading = true;
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.accessToken = params['access_token'];
      this.refreshToken = params['refresh_token'];
      this.redirect = params['redirect'];
      this.goBack = params['go_back'];
    });

    this.changeRoute();

    window.localStorage['urlToRedirect'] = this.redirect;
    window.localStorage['goBack'] = this.goBack;
    this.checkIfTokenIsValid();
  }

  changeRoute() {
    switch (this.redirect) {
      case '/pages/convenios/antecipacao-fatura':
        this.redirect = '/pages/antecipacoes/antecipacao-fatura';
        break;

      case '/pages/iclinic-pay/antecipacao-transacao':
        this.redirect = '/pages/antecipacoes/antecipacao-transacao';
        break;

      case '/pages/iclinic-pay/recebiveis/calendar':
        this.redirect = '/pages/particular/recebiveis/calendar';
        break;

      case '/pages/iclinic-pay/convenios/meus-convenios':
        this.redirect = '/pages/planos-de-saude/meus-convenios';
        break;

      default:
        break;
    }
  }

  checkIfTokenIsValid() {
    this.userService.getSelf(true, this.accessToken, this.refreshToken).subscribe(
      (res) => {
        localStorage.setItem('user', JSON.stringify(res));
        localStorage.setItem('referral', res.organizacoes[0].referral);
        this.intercomService.init();

        this.router.navigate([this.redirect]);
      },
      (err) => {
        setTimeout(() => {
          this.showLoading = false;
          this.contentLoadService.setLoadingData(['Autenticando...', false]);
        }, 3000);
      }
    );
  }

  goBackTo(): void {
    window.location.href = `https://${this.goBack}`;
  }
}
